<template>
    <Bill :menuId="page.id" :options="getOptions()" 
        :queryConditionPaneComponent="getQueryConditionPane()"
        :queryResultWorker = "getQueryResultWorker()"
        :editorComponent="getEditorComponent()"
        :queryResultKeyInfo = "getQueryResultKeyInfo()"
        :emptyRec="getEmptyRec()"
        :editorButtonPaneComponent="getEditorButtonPane()"
    >
    </Bill>
</template>

<script>
import Bill from '../../../base/bill/Bill.vue';
import Mode from '../../../base/bill/Mode.js';
import Worker from './QueryResultWorker.js';

export default {
    name: 'Smp-Person-Manage',
    props:['page'],
    components: {
        'Bill':Bill,
    },
    data () {
        return {
            queryConditionPaneComponent:null,
            queryResultPaneComponent:null, 
            editorButtonPaneComponent:null,
            editorComponent:null,
        }
    },
    methods:{
        getQueryConditionPane(){
            if(!this.queryConditionPaneComponent)
                this.queryConditionPaneComponent = (require('@/views/smp/org/person/QueryConditionPane.vue').default);
            return this.queryConditionPaneComponent;
        },
        getEditorButtonPane(){
            if(!this.editorButtonPaneComponent)
                this.editorButtonPaneComponent = (require('@/views/smp/org/person/EditorButtonPane.vue').default);
            return this.editorButtonPaneComponent;
        },
        getEditorComponent(){
            if(!this.editorComponent)
                this.editorComponent = (require('@/views/smp/org/person/Editor.vue').default);
            return this.editorComponent;
        },
        /*
        getQueryResultPane(){
            if(!this.queryResultPaneComponent)
                this.queryResultPaneComponent = (require('@/views/smp/org/person/QueryResultPane.vue').default);
            return this.queryResultPaneComponent;
        },
        */
        getQueryResultWorker(){
            return Worker;
        },
        getOptions(){
            return {
            };
        },
        getQueryResultKeyInfo(){
            return {
                itemKeyName:"userId",
                emptyItemKeyValue:-1,
            };
        },
        getEmptyRec(){
            return {
                id:-1,
                name:'',
                mobile:'',
                status:-1,
                statusName:'',
                sex:-1,
                appoints:[],
                appointRecords:[],
            };
        }
    },
    created(){
        console.log('person manage page created');
        console.log(this.page);
    },
    mounted(){
        console.log('person manage page mounted');
        console.log(this.page);
    }
}
</script>
<style scoped>
</style>
